import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loginImg from '../Img/Login-img.png'

const ResetPassword = () => {
    const [step, setStep] = useState(1); // Track current step
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState(Array(6).fill(''));
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const otpRefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const url = process.env.REACT_APP_API_URL
    const main_id = process.env.REACT_APP_PERFUME_ID
    // Handle email submission
    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            toast.error('Please enter a valid email address.');
            return;
        }

        try {
            setLoading(true);
            const response = await fetch(`${url}/registeruser/api/resetsend-otp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email,main_id:main_id }),
            });
            const data = await response.json();

            if (data.success) {
                toast.success('OTP sent to your email.');
                setStep(2);
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error('Error sending OTP');
        } finally {
            setLoading(false);
        }
    };


    // Handle OTP input
    const handleOtpChange = (e, index) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 1) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            // Move to the next input automatically
            if (value && index < otp.length - 1) {
                otpRefs.current[index + 1].focus();
            }
        }
    };

    // Verify OTP
    const handleVerifyOtp = async () => {
        const otpString = otp.join('');
        if (otpString.length !== 6) {
            toast.error('Please enter all 6 digits of OTP');
            return;
        }

        try {
            setLoading(true);
            const response = await fetch(`${url}/registeruser/api/verify-otp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, otp: otpString ,main_id:main_id}),
            });
            const data = await response.json();

            if (data.success) {
                toast.success('OTP verified successfully!');
                setStep(3);
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error('Error verifying OTP');
        } finally {
            setLoading(false);
        }
    };


    // Handle password reset
    const handlePasswordReset = async (e) => {
        e.preventDefault();

        if (password.length < 6) {
            toast.error('Password must be at least 6 characters.');
            return;
        }
        if (password !== confirmPassword) {
            toast.error('Passwords do not match.');
            return;
        }

        try {
            setLoading(true);
            const response = await fetch(`${url}/registeruser/api/reset-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, newPassword: password,main_id:main_id }),
            });
            const data = await response.json();

            if (data.success) {
                toast.success('Password reset successfully!');
                setTimeout(() => {
                    window.location.href = '/login';
                }, 2000);
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error('Error resetting password');
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <ToastContainer position="top-center" autoClose={3000} />
            <div className="login-bg">
                <div className="login-img">
                    <img src={loginImg} alt="" />
                </div>
                <div className="login-box reset-box">
                    <h2>Reset Password</h2>
                    {step === 1 && (
                        <>
                            <form onSubmit={handleEmailSubmit}>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Email address"
                                    required
                                />
                                <button type="submit" disabled={loading}>
                                    {loading ? 'Sending...' : 'Send OTP'}
                                </button>

                                <p className="register">
                                    Already register? <Link to='/login'>Login now</Link>
                                </p>
                            </form>
                        </>
                    )}
                    {step === 2 && (
                        <>
                            <p>Enter the 6-digit OTP sent to your email.</p>
                            <div className="otp-inputs">
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        type="text"
                                        maxLength="1"
                                        value={digit}
                                        onChange={(e) => handleOtpChange(e, index)}
                                        ref={(el) => (otpRefs.current[index] = el)}
                                        className="otp-input"
                                        placeholder="-"
                                    />
                                ))}
                            </div>
                            <button onClick={handleVerifyOtp} disabled={loading}>
                                {loading ? 'Verifying...' : 'Verify OTP'}
                            </button>

                            <p className="register">
                                Already register? <Link to='/login'>Login now</Link>
                            </p>
                        </>
                    )}
                    {step === 3 && (
                        <>
                            <p>Set a new password.</p>
                            <form onSubmit={handlePasswordReset}>
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="New Password"
                                    required
                                />
                                <input
                                    type="password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Confirm Password"
                                    required
                                />
                                <button type="submit" disabled={loading}>
                                    {loading ? 'Resetting...' : 'Reset Password'}
                                </button>


                                <p className="register">
                                    Already register? <Link to='/login'>Login now</Link>
                                </p>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
